import React, { useContext } from 'react'
import { useQuery } from '@apollo/client'
import { Select } from 'antd'
import { ADDRESSES_QUERY } from '../../../../graphql/User'
import CentredLoader from '../../../../components/CentredLoader'
import { SelectedAddressContext } from '../../contexts/selectedAddressContext'

const AddressSection = (): JSX.Element => {
  const { selectedAddress, setSelectedAddress } = useContext(
    SelectedAddressContext
  )

  const { data, loading } = useQuery(ADDRESSES_QUERY)

  if (loading) return <CentredLoader />

  return (
    <>
      <Select
        allowClear={true}
        style={{ width: 250 }}
        onChange={(e: number) => setSelectedAddress(e)}
        defaultValue={selectedAddress}
        placeholder={'Centre'}
      >
        {data.allAddresses.map((address: any) => (
          <Select.Option key={address.id} value={address.id}>
            {address.shortname}
          </Select.Option>
        ))}
      </Select>
    </>
  )
}

export default AddressSection
